import { createContext, useContext, type AnchorHTMLAttributes, type ComponentType } from "react";

export type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & { href: string };

const LinkContext = createContext<ComponentType<LinkProps>>((props) => <a {...props} />);

/**
 * Components that navigate (nav items, rows, "All activity") render through this.
 * Apps pass their router's link, e.g. an adapter around react-router's `<Link to>`.
 */
export function LinkProvider({
  component,
  children,
}: {
  component: ComponentType<LinkProps>;
  children: React.ReactNode;
}) {
  return <LinkContext.Provider value={component}>{children}</LinkContext.Provider>;
}

export function Link(props: LinkProps) {
  const Component = useContext(LinkContext);
  return <Component {...props} />;
}
